import {
  Button,
  darken,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  makeStyles,
} from '@material-ui/core';
import React from 'react';
import { colors } from '../../../themes';

type Props = {
  open: boolean;
  title?: string;
  message: React.ReactNode;
  confirmLabel?: string;
  showConfirmBtn?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const BillingStatusConfirmDialog: React.FC<Props> = ({
  open,
  title = 'Confirm Change',
  message,
  confirmLabel = 'Confirm',
  showConfirmBtn = true,
  onConfirm,
  onCancel,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="xs"
      className={classes.dialog}
    >
      <DialogTitle disableTypography className={classes.header}>
        <span className="linked-text">{title}</span>
      </DialogTitle>
      <Divider />
      <DialogContent className={classes.main}>
        <div className="dialog-text">{message}</div>
        <div className={classes.actions}>
          <Button
            className={`${classes.actionBtn} ${classes.cancelBtn}`}
            onClick={onCancel}
          >
            {showConfirmBtn ? 'Cancel' : 'Close'}
          </Button>
          {showConfirmBtn && (
            <Button
              className={`${classes.actionBtn} ${classes.saveBtn}`}
              onClick={onConfirm}
            >
              {confirmLabel}
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles(theme => ({
  dialog: {
    '& .MuiDialog-paperWidthXs': {
      maxWidth: 400,
    },
  },
  header: {
    fontSize: 18,
    color: '#4f4f4f',
    fontWeight: 700,
    textAlign: 'center',
    padding: theme.spacing(1),
    '& .linked-text': {
      textTransform: 'uppercase',
    },
  },
  main: {
    padding: theme.spacing(1, 0, 0),
    '& .dialog-text': {
      textAlign: 'center',
      fontSize: 16,
      padding: theme.spacing(1, 3),
      color: '#4f4f4f',
      fontWeight: 500,
    },
  },
  actions: {
    alignItems: 'center',
    borderTop: '1px solid #bdbdbd',
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    padding: theme.spacing(2, 2),
  },
  actionBtn: {
    borderRadius: 5,
    fontSize: theme.typography.body1.fontSize,
    marginLeft: theme.spacing(2),
    padding: theme.spacing(1, 4),
  },
  cancelBtn: {
    backgroundColor: colors.danger[500],
    color: 'white',
    '&:hover': {
      backgroundColor: darken(colors.danger[500], 0.15),
    },
  },
  saveBtn: {
    backgroundColor: colors.textPrimary[400],
    color: 'white',
    '&:hover': {
      backgroundColor: darken(colors.textPrimary[400], 0.15),
    },
  },
}));
